<div class="px-1" *ngIf="ID>'0'">
  <p class="m-0 tree-Content tree-Active" *ngIf="status == 'Published'">{{Text}}</p>
  <p class="m-0 tree-Content tree-Develop" *ngIf="status == 'Developing'">{{Text}}</p>
  <p class="m-0 tree-Content tree-Develop"
  [ngClass]="checkIfStudyUnit(Text) ? 'tree-StudyUnit' : 'tree-Develop'"
  *ngIf="status == 'WIP'">{{Text}}</p>
</div>
